import { render, staticRenderFns } from "./clientdashboard-bookings.vue?vue&type=template&id=c815e540&"
import script from "./clientdashboard-bookings.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-bookings.vue?vue&type=script&lang=js&"
import style0 from "./clientdashboard-bookings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports